import { Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { SuccessIconNew } from '../../../assets/images';
import { MuiButton, MuiPopup, MuiStack } from '../../../components';
import { Stack } from '@mui/material';
export default function FinishInspectionPopup(props) {
    var successfulPopup = props.successfulPopup, onClosePopup = props.onClosePopup, Jcnumber = props.Jcnumber;
    var lgMode = useMediaQuery('(min-width:600px)');
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: successfulPopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            onClosePopup(false);
        },
        padding: '15px 0px 0px 15px',
        headerIcon: SuccessIconNew,
        containerStyle: {
            width: lgMode ? '500px' : 'calc(80vw)'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        id: "submitted-successfully-popup"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t("Submitted successfully !")), /*#__PURE__*/ React.createElement(Typography, {
        id: "FI-JC-No",
        variant: "h4",
        color: '#6A7682',
        marginTop: 1
    }, t("The FI submitted successfully for JC-") + Jcnumber)), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            paddingTop: '20px'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "small",
        variant: "contained",
        name: t("BACK_TO_HOME"),
        onClick: function () { return onClosePopup(false); },
        fullWidth: true
    }))));
}
